// Zentrale ENV-Auflösung. Wir haben `VITE_MANAGEMENT_URL` an mehreren Stellen
// genutzt — wenn das jemals abweicht, kommt es zu silent Routing-Bugs.
//
// Prod-Default = LEER = **same-origin/relativ**: das Master-Image served die gebaute SPA
// selbst unter /ui (ENV ADMIN_UI_DIST) → die API liegt auf demselben Origin, relative
// Pfade treffen sie ohne CORS und ohne eingebackene Domain (EIN Image für alle Kunden).
// Dev (Vite :5173, getrennt vom Master) behält den localhost-Default; Override via .env.

export const MANAGEMENT_URL: string =
  import.meta.env.VITE_MANAGEMENT_URL ?? (import.meta.env.DEV ? "http://127.0.0.1:3001" : "");

// #215 (E2): Browser-erreichbare Gitea-Web-URL für Repo/Branch-Links aus der Admin-UI.
// Lokal dieselbe, die der Master nutzt (127.0.0.1:3002); in Prod die öffentliche URL.
export const GITEA_WEB_URL: string =
  import.meta.env.VITE_GITEA_URL ?? "http://127.0.0.1:3002";

// Baut den Gitea-Web-Link für ein Seed-Repo ("owner/repo") + optional Branch.
// Mit Branch → Branch-Code-Ansicht, sonst Repo-Root.
export function giteaSeedUrl(repoFullName: string, branch?: string | null): string {
  const base = `${GITEA_WEB_URL}/${repoFullName}`;
  return branch ? `${base}/src/branch/${branch}` : base;
}
